import React from 'react';
import WizardModalWrapperLayout from 'Views/Page/Content/Modal/Layouts/WizardModalWrapperLayout';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';

const useStyles = makeStyles(() => ({
  form: {
    width: '100%',
  },
}));

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const classes = useStyles();
  return (
    <WizardModalWrapperLayout>
      <PageContentTop
        resource={resource}
        badgeImage={resource.attr('badgeImage')}
        badgeImageAlt={resource.attr('badgeImageAlt')}
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />
      <br />
      <MetaFormFields resource={resource} className={classes.form} />
    </WizardModalWrapperLayout>
  );
};

export default Layout;
